import type { TrapGroup } from '@features/regional-overview/digital-traps/domain';
import { create } from 'zustand';

interface FlightCurveStore {
  selectedNetwork?: TrapGroup;
  selectedTraps: string[];
  selectedDays: number; // Optional, if needed in the future

  setSelectedNetwork: (network: TrapGroup) => void;
  setSelectedTraps: (traps: string[]) => void;
  setSelectedDays: (days: number) => void;
}

export const useFlightCurveStore = create<FlightCurveStore>(set => ({
  selectedNetwork: undefined,
  selectedTraps: ['all'],
  selectedDays: 7,
  setSelectedNetwork: (network: TrapGroup) => set({ selectedNetwork: network }),
  setSelectedTraps: (traps: string[]) => set({ selectedTraps: traps }),
  setSelectedDays: (days: number) => set({ selectedDays: days })
}));
